<template>
  <div class="horizontal-line">
    <hr :style="'background-color: ' + color">
  </div>
</template>

<script lang="babel">
export default {
  name: "HorizontalLine",
  props: {
    color: {
      type: String,
      default: '#F8F8F8'
    }
  }
}
</script>

<style lang="scss" scoped>
.horizontal-line {
  margin: 0 calc(50% - 50vw);

  hr {
    border: none;
    height: 4px;
  }
}
</style>
